import React from 'react';
import { useParams } from 'react-router-dom';
import ZoneList from '../components/Zones/ZoneList';
import ZoneDetail from '../components/Zones/ZoneDetail';

export default function ZonesPage() {
  const { name } = useParams();

  if (name) {
    return <ZoneDetail />;
  }

  return <ZoneList />;
}
